import styled from"@emotion/styled";import{FlexLayout}from"@wp/src/components/common/grid";import PortfolioChangeScoreImpact from"../../portfolioScoreImpact/PortfolioChangeScoreImpact";export const OptimizerDescription=styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  color: ${props=>props.theme.colors.neutral900};
`;export const PortfolioOptimizerRecommendationsContainer=styled(FlexLayout)`
  color: ${props=>props.theme.colors.blue700};
  justify-content: flex-start;
  cursor: pointer;
`;export const OptimizerChangeScoreImpact=styled(PortfolioChangeScoreImpact)`
  padding: 0;
`;export const StyledSelectionContainer=styled.div`
  .ant-select-item-option-grouped {
    padding-inline-start: 12px;
  }
`;